/* ======================  SCRIPTS ====================== */
/************  JQUERY EST DISPONIBLE ICI *****************/

    $('document').ready(setup);

    function setup() {
        // initTarteAuCitron();
        initGTag();
        initSlickSlider();
        initBlockMedia();
    }

/*function initTarteAuCitron() {
    tarteaucitron.init({
        "hashtag": "#tarteaucitron", /!* Ouverture automatique du panel avec le hashtag *!/
        "highPrivacy": true, /!* désactiver le consentement implicite (en naviguant) ? *!/
        "orientation": "bottom", /!* le bandeau doit être en haut (top) ou en bas (bottom) ? *!/
        "adblocker": false, /!* Afficher un message si un adblocker est détecté *!/
        "showAlertSmall": false, /!* afficher le petit bandeau en bas à droite ? *!/
        "cookieslist": true, /!* Afficher la liste des cookies installés ? *!/
        "removeCredit": true, /!* supprimer le lien vers la source ? *!/
        "useExternalCss": true
    });
    tarteaucitron.user.gtagUa = 'UA-70693728-1';
    tarteaucitron.user.gtagMore = function () { /!* add here your optionnal gtag() *!/ };
    (tarteaucitron.job = tarteaucitron.job || []).push('gtag');
}*/

function initGTag() {
    window.dataLayer = window.dataLayer || [];
    function gtag(){window.dataLayer.push(arguments);}
    gtag('js', new Date());

    gtag('config', 'UA-70693728-1');
}

// Fonction pour initialiser les sliders avec Slick
function initSlickSlider() {
    $('.blockslider-slides').slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 800,
        fade: false,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: true,
        adaptiveHeight: true,
        slidesToShow: 1,
        cssEase: 'ease-in-out'
    });
}

// Fonction qui permet de lire une vidéo
function initBlockMedia() {
    $('.blocktextimg-media.has-video, .blockmedia-media.has-video').click(function() {
        if(!$(this).hasClass('showVideo')) $(this).addClass('showVideo');
    });
}

/************  Menu mobile *****************/

$(document).ready( function(){
    // Affiche le menu mobile
    $('.burger').click( function(e) {
        e.preventDefault();
        toggleMenu();
    });
});

// Gère l'ouverture/fermeture du menu et des élements associés
function toggleMenu( action ) {
    $('.navigation__mobile').toggleClass("menu-active");
    $('.burger').toggleClass("open");
}

$( window ).resize(function() {
    if( $(document).width() > 1199 && $('.navigation__mobile').hasClass('menu-active')) {
        toggleMenu();
    }
});

//faq toggle stuff
$('.togglefaq').click(function(e) {
    e.preventDefault();
    var notthis = $('.active').not(this);
    // notthis.find('.icon-minus').addClass('icon-plus').removeClass('icon-minus');
    notthis.toggleClass('active').next('.faqanswer').slideToggle(200);
    $(this).toggleClass('active').next().slideToggle("fast");
    $(this).children('i').toggleClass('icon-plus icon-minus');
});

$('.cat-1').click(function () {
    $(window).scrollTop(0);
})
if ($('.blocFaqButtons__content')[0] && $(document).width() > 1000){
    $(window).on('scroll', function(){
        var content = (window.pageYOffset + $('.blocFaqButtons__content').height());
        var wrapper = $('.blocFaqButtons__wrapper').height();
        if (content >= wrapper) {
            $('.blocFaqButtons__content').removeClass('sticky');
            $('.blocFaqButtons__content').addClass('to-bottom');
        }
        if ($('.blocFaqButtons__content').hasClass('to-bottom') && content < wrapper ) {
            $('.blocFaqButtons__content').addClass('sticky').removeClass('to-bottom');
        }
    });
}
// $(document).ready(function() {
//     //Form dynamique
//     if ($('.wpcf7-form')[0]){
//         if($('.from-checkbox input').is(':checked')){
//             $(':input[type="submit"]').prop('disabled', false);
//             $(':input[type="submit"]').removeClass('disabled');
//         }else{
//             $(':input[type="submit"]').prop('disabled', true);
//             $(':input[type="submit"]').addClass('disabled');
//         }
//         $('.from-checkbox input').click(function(){
//             if($(this).is(':checked')){
//                 $(':input[type="submit"]').prop('disabled', false);
//                 $(':input[type="submit"]').removeClass('disabled');
//             }else{
//                 $(':input[type="submit"]').prop('disabled', true);
//                 $(':input[type="submit"]').addClass('disabled');
//             }
//         });
//     }
// })

//navigation tel

if($('.navigation__tel')[0]){
    $('.navigation__tel').each(function (){
        $(this).attr("href", 'tel:' + $(this).text().replace(/\s/g, ''))
    })
}

